import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  FlatList,
  ScrollView,
  TouchableOpacity,
  TextInput,
  useWindowDimensions,
} from "react-native";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else } from "react-if";
import { FormattedMessage } from "react-intl";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import Icon from "react-native-vector-icons/FontAwesome";

const Traceability = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;
  const { width } = useWindowDimensions();
  const isSmallScreen = width < 600;

  const fetchData = async () => {
    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      let apiUrl;

      const url = window.location.href;
      if (url.includes("localhost")) {
        apiUrl = "http://localhost/api/movimentActivesList";
      } else if (url.includes("homol.gpxecofi.com.br")) {
        apiUrl = "https://api.homol.gpxecofi.com.br/api/movimentActivesList";
      } else {
        apiUrl = "https://api.gpxecofi.com.br/api/movimentActivesList";
      }

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const sortedData = sortByDate(response.data.data);
      setData(sortedData);
      setTotalPages(Math.ceil(sortedData.length / itemsPerPage));
    } catch (error) {
      console.error("Erro ao buscar os dados:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = data.filter((item) =>
    item.name_token.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const currentItems = filteredData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const sortByDate = (data) => {
    return data.sort((a, b) => {
      const dateA = new Date(`${a.data_transacao}T${a.hora_transacao}`);
      const dateB = new Date(`${b.data_transacao}T${b.hora_transacao}`);
      return dateB - dateA;
    });
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const renderItem = ({ item }) => (
    <View style={styles.row}>
      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblDataHora" />
        </Text>
        <Text style={styles.itemText}>{item.data_transacao}</Text>
        <Text style={styles.subItemText}>{item.hora_transacao}</Text>
      </View>

      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblTipo" />
        </Text>
        <If condition={item.type.includes("Recebeu")}>
          <Then>
            <Text style={styles.itemText}>
              <FormattedMessage id="traceability.receivedTypeMessage" />
            </Text>
          </Then>

          <Else>
            <If condition={item.type.includes("Transferencia")}>
              <Then>
                <Text style={styles.itemText}>
                  <FormattedMessage id="traceability.transferTypeMessage" />
                </Text>
              </Then>

              <Else>
                <Text style={styles.itemText}>{item.type}</Text>
              </Else>
            </If>
          </Else>
        </If>
      </View>

      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblAtivo" />
        </Text>
        <Text style={styles.itemText}>
          {item.name_token.split(" ").join("\n")}
        </Text>
      </View>

      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblQuantidade" />
        </Text>
        <Text style={styles.itemText}>
          {Math.round(item.qtde_transacionada)}
        </Text>
      </View>

      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblValor" />
        </Text>
        <Text style={styles.itemText}>{item.valor_transacionada}</Text>
      </View>

      <View style={styles.column}>
        <Text style={styles.lbl}>
          <FormattedMessage id="traceability.lblStatus" />
        </Text>
        <Text style={styles.itemText}>{item.status}</Text>
      </View>
    </View>
  );

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="traceability.headerTitle" />}
        subtitle={<FormattedMessage id="traceability.headerSubtitle" />}
      />
      <ScrollView>
        <View style={styles.cardContainer}>
          <Text style={styles.headerCardTransas}>
            <FormattedMessage id="traceability.cardHeaderTransas" />
          </Text>

          <View style={styles.searchContainer}>
            <FormattedMessage id="traceability.placeholderBusqueAtivo">
              {(placeholder) => (
                <TextInput
                  style={styles.input}
                  placeholder={placeholder}
                  value={searchQuery}
                  onChangeText={setSearchQuery}
                />
              )}
            </FormattedMessage>
            <Icon
              name="search"
              size={24}
              color="#077A97"
              style={styles.searchIcon}
            />
          </View>
          <FlatList
            data={currentItems}
            renderItem={renderItem}
            keyExtractor={(item, index) => index.toString()}
            ListEmptyComponent={
              <Text style={styles.emptyText}>No data found</Text>
            }
          />

          <View style={styles.paginationContainer}>
            <View
              style={[
                styles.rowBtnsPagination,
                { flexDirection: isSmallScreen ? "column" : "row", gap: 10 },
              ]}
            >
              <TouchableOpacity
                onPress={handlePreviousPage}
                disabled={page === 1}
                style={[
                  styles.btnBack,
                  { width: isSmallScreen ? "100%" : "10%" },
                ]}
              >
                <Text style={{ color: "#077A97", fontSize: 14 }}>
                  <FormattedMessage id="traceability.btnTxtAnterior" />
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={handleNextPage}
                disabled={page === totalPages}
                style={[
                  styles.btnNext,
                  { width: isSmallScreen ? "100%" : "10%" },
                ]}
              >
                <Text style={{ color: "#FFF", fontSize: 14 }}>
                  <FormattedMessage id="traceability.btnTxtPróxima" />
                </Text>
              </TouchableOpacity>
            </View>
            <Text>
              <FormattedMessage
                id="traceability.currentPage"
                values={{ page: page, totalPages: totalPages }}
              />
            </Text>
          </View>
        </View>
      </ScrollView>
    </>
  );
};

export default Traceability;
